import React from 'react';
import { Header } from '../components/Header';
import { Button } from '../components/Button';
import { SearchXIcon } from 'lucide-react';
interface EmptyScreenProps {
  onLogout: () => void;
  onClearFilters: () => void;
}
export function EmptyScreen({
  onLogout,
  onClearFilters
}: EmptyScreenProps) {
  return <div className="h-screen flex flex-col bg-navy" data-id="element-663" data-mp="wi30nc9ono6c">
      <Header breadcrumbs={[{
      label: 'Cases'
    }, {
      label: 'Smith v. Acme Corp'
    }, {
      label: 'Review'
    }]} onLogout={onLogout} data-id="element-664" data-mp="wgjjzkk47b41" />

      <div className="flex-1 flex items-center justify-center p-4" data-id="element-665" data-mp="3rm1phfwleba">
        <div className="text-center max-w-md" data-id="element-666" data-mp="ijd3xxqrzqii">
          <div className="w-16 h-16 bg-navy-light rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-667" data-mp="drv277gxhlwh">
            <SearchXIcon className="w-8 h-8 text-gray-500" data-id="element-668" data-mp="3m7espyq7sq7u" />
          </div>
          <h2 className="text-2xl font-serif text-white mb-2" data-id="element-669" data-mp="3m5breijm3ant">
            No documents found
          </h2>
          <p className="text-gray-400 mb-8" data-id="element-670" data-mp="tg1eywgqobf3">
            Try adjusting your search or filters to find what you're looking
            for.
          </p>
          <Button onClick={onClearFilters} data-id="element-671" data-mp="ydtgmi76rbwh">Clear Filters</Button>
        </div>
      </div>
    </div>;
}